import { Div, Image, List, ListItem, P, Span } from '@kizi/core-components';
import { Anchor, IconV2 as Icon } from '@kizi/shared-components';
import React from 'react';
import { ProsConsItem } from '../../ProsCons';
import { Banner } from '../../Banner';

const Schuindak = React.memo(() => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99264 8.82612L9.49264 2.59279C9.56485 2.5317 9.65638 2.49818 9.75097 2.49818C9.84556 2.49818 9.93709 2.5317 10.0093 2.59279L17.5093 8.82612C17.6334 8.92838 17.7766 9.00486 17.9306 9.05106C18.0846 9.09727 18.2463 9.11227 18.4062 9.0952C18.566 9.07813 18.7209 9.02932 18.8617 8.95163C19.0024 8.87395 19.1263 8.76895 19.226 8.64279C19.4316 8.38466 19.5284 8.05647 19.4957 7.72807C19.463 7.39966 19.3035 7.09698 19.051 6.88445L11.551 0.642788C11.0432 0.227117 10.4072 0 9.75097 0C9.09475 0 8.45875 0.227117 7.95097 0.642788L0.450968 6.88445C0.198483 7.09698 0.0389156 7.39966 0.00623082 7.72807C-0.0264539 8.05647 0.0703253 8.38466 0.275968 8.64279C0.375644 8.76895 0.499497 8.87395 0.640268 8.95163C0.78104 9.02932 0.9359 9.07813 1.09578 9.0952C1.25565 9.11227 1.41733 9.09727 1.57133 9.05106C1.72533 9.00486 1.86856 8.92838 1.99264 8.82612Z"
      fill="#12DE9A"
    />
    <path
      d="M18.3593 18.3345V12.5011C18.3529 12.2506 18.2957 12.0039 18.1912 11.7762C18.0866 11.5484 17.9368 11.3443 17.751 11.1761L10.8343 5.34279C10.5428 5.09717 10.1738 4.96246 9.79263 4.96246C9.41143 4.96246 9.04249 5.09717 8.75097 5.34279L1.8343 11.1761C1.64844 11.3443 1.49868 11.5484 1.3941 11.7762C1.28953 12.0039 1.23233 12.2506 1.22597 12.5011V18.3345C1.22597 18.7765 1.40156 19.2004 1.71412 19.513C2.02668 19.8255 2.45061 20.0011 2.89264 20.0011H7.34264C7.56365 20.0011 7.77561 19.9133 7.93189 19.757C8.08817 19.6008 8.17597 19.3888 8.17597 19.1678V14.5845C8.17597 14.3634 8.26377 14.1515 8.42005 13.9952C8.57633 13.8389 8.78829 13.7511 9.0093 13.7511H10.676C10.897 13.7511 11.1089 13.8389 11.2652 13.9952C11.4215 14.1515 11.5093 14.3634 11.5093 14.5845V19.1678C11.5093 19.3888 11.5971 19.6008 11.7534 19.757C11.9097 19.9133 12.1216 20.0011 12.3426 20.0011H16.826C17.2445 19.9675 17.6349 19.7772 17.9192 19.4682C18.2035 19.1592 18.3606 18.7543 18.3593 18.3345Z"
      fill="#2B2F3B"
    />
  </svg>
));

const orderMap = {
  pv_panel: 1,
  pv_inverter: 2,
  pv_option: 3,
};

function createPanelBlock(coverageHome) {
  const { externalSourceName, documents, solarPanels } = coverageHome;
  const { width, height, yearlyLoss, wattPeak, color } = solarPanels['0'];

  return {
    refTypeDescription: 'pv_panel',
    image:
      documents.find((el) => el.attachmentType === 'V04')?.urlAttachment ===
      undefined
        ? externalSourceName === 'Longi 405wp Paneel'
          ? 'https://app.salesdock.nl/storage/225/product/57721/Qdr6dhMboMkqh19MEpJ1.jpeg'
          : 'https://app.salesdock.nl/storage/225/product/57722/no39V7lbUpCAlKBNA1qW.png'
        : documents.find((el) => el.attachmentType === 'V04')?.urlAttachment,
    label: externalSourceName,
    specs: [
      { label: 'Wattpiek', value: wattPeak },
      { label: 'Uitvoering', value: color },
      {
        label: 'Afmetingen',
        value: (
          <Div>
            <b>B:</b>
            {width} x <b>H:</b>
            {height}
          </Div>
        ),
      },
      { label: 'Jaarlijks verlies', value: `${yearlyLoss} %` },
      {
        label: 'Downloads',
        fileLabel: `Data-${externalSourceName.replace(/\s+/g, '-')}.pdf`,
        value: documents.find((el) => el.attachmentType === 'V06')
          ?.urlAttachment,
      },
    ],
  };
}

function createInverterBlock(coverageHome) {
  const { externalSourceName, documents, uniqueSellingPoint, solarPanels } =
    coverageHome;
  const { powerOutput, maxPower } = solarPanels['0'];
  return {
    refTypeDescription: 'pv_inverter',
    image:
      documents.find((el) => el.attachmentType === 'V04')?.urlAttachment ===
      undefined
        ? externalSourceName === 'Longi 405wp Paneel'
          ? 'https://app.salesdock.nl/storage/225/product/57721/Qdr6dhMboMkqh19MEpJ1.jpeg'
          : 'https://app.salesdock.nl/storage/225/product/57722/no39V7lbUpCAlKBNA1qW.png'
        : documents.find((el) => el.attachmentType === 'V04')?.urlAttachment,
    sellingPoints: uniqueSellingPoint ? uniqueSellingPoint.split('\r\n') : [],
    label: externalSourceName,
    specs: [
      { label: 'Vermogen', value: powerOutput },
      { label: 'Max. vermogen', value: maxPower },
      {
        label: 'Downloads',
        fileLabel: `Data-${externalSourceName.replace(/\s+/g, '-')}.pdf`,
        value: documents.find((el) => el.attachmentType === 'V06')
          ?.urlAttachment,
      },
    ],
  };
}

function createOptionBlock(coverageHome) {
  const { externalSourceName, documents, uniqueSellingPoint } = coverageHome;

  return {
    refTypeDescription: 'pv_option',
    icon:
      externalSourceName === 'Installatie' ? (
        <Div mb={1}>
          <Schuindak />
        </Div>
      ) : externalSourceName === 'Serviceplan' ? (
        <Icon name="texting" width={24} height={24} mb={1} />
      ) : null,
    image:
      documents.find((el) => el.attachmentType === 'V04')?.urlAttachment ===
      undefined
        ? externalSourceName === 'Longi 405wp Paneel'
          ? 'https://app.salesdock.nl/storage/225/product/57721/Qdr6dhMboMkqh19MEpJ1.jpeg'
          : 'https://app.salesdock.nl/storage/225/product/57722/no39V7lbUpCAlKBNA1qW.png'
        : documents.find((el) => el.attachmentType === 'V04')?.urlAttachment,
    sellingPoints: uniqueSellingPoint.split('\r\n'),
    label: externalSourceName,
  };
}

export const ProductModalContent = ({ data }) => {
  const blocks: any[] = [];
  if (data) {
    data.coverageHomes.forEach((coverageHome) => {
      const { refTypeDescription } = coverageHome;

      if (refTypeDescription === 'pv_panel') {
        blocks.push(createPanelBlock(coverageHome));
      } else if (refTypeDescription === 'pv_inverter') {
        blocks.push(createInverterBlock(coverageHome));
      } else if (
        refTypeDescription === 'pv_option' &&
        coverageHome.uniqueSellingPoint
      ) {
        blocks.push(createOptionBlock(coverageHome));
      }
    });
  }

  const orderedBlocks = [...blocks].sort((a, b) => {
    const aOrder = orderMap[a.refTypeDescription] || Number.MAX_SAFE_INTEGER;
    const bOrder = orderMap[b.refTypeDescription] || Number.MAX_SAFE_INTEGER;
    return aOrder - bOrder;
  });

  const bannerContent = [
    {
      title: 'Productgarantie',
      body: 'De productgarantie zit op zowel de zonnepanelen zelf als op de omvormer(s). Deze garantie is van toepassing op defecten van het product, niet op een geleidelijke achteruitgang van de opbrengst. Op omvormers is 5 jaar het minimum, maar 10 jaar of meer wordt ook aangeboden.',
    },
    {
      title: 'Vermogensgarantie',
      body: "Deze zit altijd op zonnepanelen, en is van toepassing op geleidelijke achteruitgang van de productie van werkende panelen. Gangbaar is een garantie op 80% van het vermogen na 20 of 25 jaar. Maar hogere percentages of een langere termijn komen ook voor. Vraag of de vermogensgarantie 'lineair' is. Dat betekent: als je zonnepanelen al na 12 jaar meer dan 0,5% per jaar achteruit gaat, je niet tot jaar 20 hoeft te wachten om op deze garantie aanspraak te doen.",
    },
  ];

  return (
    <>
      <Div
        display="grid"
        gridTemplateColumns={[null, null, '1fr 1fr']}
        gridTemplateRows={['1fr', '1fr', null]}
        gridGap={['24px', '24px', '40px']}
        mb={['24px', '24px', '40px']}
      >
        {orderedBlocks.slice(0, 2).map((el) => (
          <Div key={el.label} flex={1}>
            {el.image && (
              <Image
                src={el.image}
                alt="Solar Panel image"
                height="72px"
                style={{ objectFit: 'contain' }}
              />
            )}
            {el.icon}
            <P variant="bodyImportant" mb={2}>
              {el.label}
            </P>
            {el?.sellingPoints?.map((sp, i) => (
              <ProsConsItem key={i} mt={2} text={sp} type="pros" />
            ))}
            {el?.specs?.map((spec, i) => {
              const { label, value } = spec;
              let content;
              if (label === 'Downloads') {
                content = (
                  <Div key={i}>
                    <Anchor
                      href={value}
                      variant="inputFootnote"
                      target="_blank"
                      style={{
                        textDecoration: 'none',
                        fontWeight: 700,
                      }}
                      rel="noreferrer"
                      download
                    >
                      <Icon
                        name="document"
                        width={20}
                        height={20}
                        fill="main.1"
                        style={{
                          verticalAlign: 'bottom',
                        }}
                        mr={2}
                      />
                      <Span color="main.1">{spec.fileLabel}</Span>
                    </Anchor>
                    <Div variant="divider" my={2} />
                  </Div>
                );
              } else {
                content = (
                  <Div>
                    <P variant="footnoteImportant">{label}</P>
                    <P variant="footnoteRegular">{value}</P>
                    <Div variant="divider" my={2} />
                  </Div>
                );
              }
              return content;
            })}
          </Div>
        ))}
      </Div>
      <Banner
        background="#F0F0EF"
        iconName="info"
        mb={orderedBlocks.length > 2 ? 8 : 0}
        mt={8}
        content={bannerContent}
        flexDirection="column"
        alignItems="flex-start"
        iconProps={{
          name: 'info',
          paddingBottom: 2,
          fill: '#2B2F3B',
        }}
      />
      {orderedBlocks.length > 2 && (
        <Div
          display="grid"
          gridTemplateColumns={[null, null, '1fr 1fr']}
          gridTemplateRows={['1fr', '1fr', null]}
          gridGap={['24px', '24px', '40px']}
          mb={['24px', '24px', '40px']}
        >
          {orderedBlocks.slice(2).map((el) => (
            <Div key={el.label} flex={1}>
              {el.image && (
                <Image
                  src={el.image}
                  alt="Solar Panel image"
                  height="72px"
                  style={{ objectFit: 'contain' }}
                />
              )}
              {el.icon}
              <P variant="bodyImportant" mb={2}>
                {el.label}
              </P>
              <List css={{ listStyle: 'disc' }}>
                {el.sellingPoints.map((sp, i) => (
                  <ListItem key={i}>
                    <P variant="footnoteRegular">{sp}</P>
                  </ListItem>
                ))}
              </List>
            </Div>
          ))}
        </Div>
      )}
    </>
  );
};
